module.exports = new __parcel__URL__("filter_oumanger.0e33aac2.png").toString();